import React, { useState } from 'react';
import { ReactComponent as DropdownIcon } from '../components/svgs/dropdownIcon.svg';

const InputDropdown = ({
  options,
  onSelect,
  inputClass,
  inputWidth = '200px',
  iconMargin = '1px',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleInputClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    onSelect(option);
  };

  return (
    <>
      <div className="input-dropdown">
        <input
          type="text"
          placeholder="Select an option"
          value={selectedOption ? selectedOption.label : ''}
          onClick={handleInputClick}
          readOnly
          className={`${inputClass} service-input-dropdown`}
          style={{ width: inputWidth }}
        />
        <DropdownIcon
          className="dropdown-icon"
          onClick={handleInputClick}
          style={{ marginRight: iconMargin }}
        />
        {isOpen && (
          <ul className="options">
            {options.map((option, index) => (
              <li key={index} onClick={() => handleOptionClick(option)}>
                {option.label}
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default InputDropdown;